import { ComponentType, useRef } from 'react'
import useOnclickOutside from 'react-cool-onclickoutside'
import usePortal from 'react-cool-portal'
import { Button } from 'reactstrap'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: fixed;
  top: calc(70px + 60px);
  left: 0;
  right: 0;
  max-height: 50vh;
  background: white;
  z-index: 500;
  box-shadow: 0 9px 24px 0 rgba(0, 0, 0, 0.1);
`

interface Props {
  label: string
  disabled?: boolean
  isOpen: boolean
  isActive: boolean
  onToggle: () => void
}

export const FilterMobile: ComponentType<Props> = ({ label, disabled, isOpen, isActive, onToggle, children }) => {
  const button = useRef<HTMLButtonElement>(null)
  const container = useRef<HTMLDivElement>(null)

  const { Portal } = usePortal({
    clickOutsideToHide: false,
    escToHide: false,
    internalShowHide: false,
  })

  useOnclickOutside([button, container], () => onToggle(), {
    disabled: !isOpen,
  })

  return (
    <>
      <Button
        innerRef={button}
        className="text-nowrap"
        color={isActive ? 'primary' : 'dimmed'}
        active={isOpen}
        outline={!isActive}
        disabled={disabled}
        onClick={onToggle}
      >
        {label}
      </Button>
      {isOpen && (
        <Portal>
          <Wrapper ref={container}>{children}</Wrapper>
        </Portal>
      )}
    </>
  )
}
